module.exports = __webpack_public_path__ + "static/img/B (14).f5d96ec6.png";